import { render, staticRenderFns } from "./DataQualityActions.vue?vue&type=template&id=0a4bcc82&scoped=true"
import script from "./DataQualityActions.vue?vue&type=script&lang=js"
export * from "./DataQualityActions.vue?vue&type=script&lang=js"
import style0 from "./DataQualityActions.vue?vue&type=style&index=0&id=0a4bcc82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4bcc82",
  null
  
)

export default component.exports